/**
 *
 *
 *
 */
export const init = function() {
  
  if ( document.getElementById('fsIframe') ) {

    let timeOut;

    adjustLayoutForHeaderHeight();

    window.addEventListener( 'resize', () => {

      if ( timeOut ) window.cancelAnimationFrame( timeOut );

      timeOut = window.requestAnimationFrame(() => {
        adjustLayoutForHeaderHeight();
      });

    }, false );

  }

};


/**
 *
 *
 *
 */
export const adjustLayoutForHeaderHeight = function() {
  
  const header          = document.getElementById('header')
  const main            = document.getElementById('main');
  const announcementBar = document.getElementById('announcement_bar');
  const adminBar        = document.getElementById('wpadminbar');
  const headerRect      = header.getBoundingClientRect();

  let topVal = 0;

  if ( headerRect.height === 0 ) {
    topVal = 70;
  } else {
    topVal = headerRect.height;
  }

  // add announcement bar height if necessary
  if ( announcementBar ) {
    const announcementBarRect = announcementBar.getBoundingClientRect();
    topVal += announcementBarRect.height;
  }

  // add admin bar height if necessary
  if ( adminBar ) {
    const adminBarRect = adminBar.getBoundingClientRect();
    topVal += adminBarRect.height;
  }

  main.style.top = ( topVal / 16 ) + 'rem';

}